<template>
    <!-- 对话框 -->
    <el-dialog :visible.sync="show" :before-close="closeDialog" width="70%">

        <!-- 基本信息表单 -->
        <div class="form-box">


            <el-form ref="form" :model="submit_data" label-width="80px" style="overflow-y: auto; height: 68vh;">

                <div>

                    <el-form-item label="商家名称:" label-width='100px'>

                        <el-input v-model="submit_data.name" style="width: 150px;" @keyup.enter.native="listBusiness"></el-input>


                    </el-form-item>

                    <el-form-item label="手机号:" label-width='100px'>

                        <el-input v-model="submit_data.phone" style="width: 150px;" maxlength=11 @keyup.enter.native="listBusiness"></el-input>


                    </el-form-item>
                    <el-form-item label="商家状态:" label-width='100px'>

                        <el-select
                                v-model="submit_data.status"
                                clearable
                                style="position: relative;width: 200px;margin-right: 5px;"
                        >
                            <el-option label="有效" value="1"></el-option>
                            <el-option label="禁用" value="0"></el-option>

                        </el-select>

                        <el-button @click="searchlistBusiness">搜索</el-button>
                        <el-button @click="addBusiness = !addBusiness" type="primary">添加</el-button>
                    </el-form-item>




                </div>


                <!-- 表格 -->
                <el-table :data="tableData_children" style="width: 100%" height="50vh" ref="multipleTable"
                          header-cell-class-name="table-header"
                          >



                    <el-table-column prop="name" label="商家名称">
                    </el-table-column>
                    <el-table-column prop="phone" label="手机号">
                    </el-table-column>
                    <el-table-column prop="status" label="状态">
                        <template slot-scope="scope">
                            {{scope.row.status == '1'?'有效':'禁用'}}
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" width="180">
                        <template slot-scope="scope">
                            <el-button @click="edit(scope.row.phone)">编辑</el-button>
                        </template>
                    </el-table-column>



                </el-table>



                <!-- 分页组件 -->
                <div class="pagination">
                    <pages :search_data="submit_data" :result_data="result_data_children" @pages_function="pages_function"></pages>
                </div>

            </el-form>

            <!-- 对话框底部按钮 -->
            <div style="display: flex;justify-content: center">

                <el-button @click="closeDialog">关闭</el-button>
            </div>

        </div>

        <addBusiness :isShow="addBusiness" @onSubmit="searchlistBusiness"></addBusiness>

        <editBusiness :isShow="editBusiness" @onSubmit="searchlistBusiness" :data="editBusiness_data"></editBusiness>

    </el-dialog>
</template>

<script>
    var _this;
    import addBusiness from './addBusiness.vue';
    import editBusiness from './editBusiness.vue';
    export default {
        props: {
            'isShow': Boolean,
        },
        components: {
            addBusiness,
            editBusiness
        },
        watch: {

            isShow(newData, oldData) {

                _this.show = true;

                _this.listBusiness();

            },

        },
        data() {
            return {
                show: false,


                addBusiness:false,
                editBusiness:false,
                editBusiness_data:'',



                tableData_children: [],

                result_data_children:[],



                submit_data:{
                    page: 1,
                    limit: 10,
                    name: '',
                    phone:'',
                    status:''
                },


            };
        },
        created() {

            _this = this;



        },
        methods: {
            edit(phone){
                _this.editBusiness = !_this.editBusiness;
                _this.editBusiness_data = phone;
            },

            searchlistBusiness(){
                _this.submit_data.page = 1;
                _this.listBusiness();
            },

            // 翻页组件的回调
            pages_function(search_data) {

                //赋值
                _this.submit_data = search_data;
                //初始化列表
                _this.listBusiness();
            },
            // 获取乘客编码
            listBusiness(){



                    _this.$post(
                        '/activity/listBusiness',
                        _this.submit_data
                    )
                        .then(res => {

                            // 将请求的数据存放到表格数据数组中
                            _this.tableData_children = res.data;
                            _this.result_data_children = res;

                        }).catch((err) => {

                    });



            },


            // 关闭方法
            closeDialog() {

                _this.show = false;

                _this.submit_data = {
                    page: 1,
                    limit: 10,
                    name: '',
                    phone:'',
                    status:''
                };



            }


        }
    };
</script>

<style scoped>
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .el-form-second {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .avatar-uploader {
        width: 100px;
        height: 100px;
    }
</style>
